import { Edit } from "@mui/icons-material";
import { Card, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "./Form";
import { getAllTax, getSingleTax } from "redux/festures/taxSlice";

const columns = {
  AllTax: [
    { Header: "S.No", accessor: "no" },
    { Header: "Tax Percent", accessor: "Tax Percent" },
    { Header: "Apply On", accessor: "Apply On" },
    { Header: "action", accessor: "action" },
  ],
};

const Tax = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const { Loading, tax } = useSelector((state) => ({ ...state?.isTax }));

  const canCreateMore = useMemo(() => {
    if (!Array.isArray(tax)) return true;
    const types = tax.map((t) => t?.applyOn).filter(Boolean);
    return !types.includes("SERVICE") || !types.includes("ECOMMERCE");
  }, [tax]);

  useEffect(() => {
    dispatch(getAllTax(`${process.env.REACT_APP_APII}/getAllTax/${admin}`));
  }, []);

  useEffect(() => {
    if (tax && tax.length > 0) {
      const temprows = tax.map((value, index) => ({
        no: (
          <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
            {index + 1}
          </MDTypography>
        ),
        "Tax Percent": (
          <MDBox flexDirection="column">
            <MDTypography fontSize={12.5}>{value?.taxPercent ?? "N/A"}%</MDTypography>
          </MDBox>
        ),
        "Apply On": (
          <MDBox flexDirection="column">
            <MDTypography fontSize={12.5}>{value?.applyOn || "N/A"}</MDTypography>
          </MDBox>
        ),
        action: (
          <IconButton
            aria-label="action_edit"
            onClick={() => {
              setIsOpen(true);
              setIsOpenUpdate(true);
              dispatch(getSingleTax(`/getTaxById/${value?._id}/${admin}`));
            }}
          >
            <Edit
              sx={({ palette: { dark, white, info } }) => ({
                color: darkMode ? info.main : dark.main,
              })}
            />
          </IconButton>
        ),
      }));
      setRowsData(temprows);
    } else {
      setRowsData([]);
    }
  }, [tax, darkMode, admin, dispatch]);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Tax&apos;s Table
              </MDTypography>
              {canCreateMore ? (
                <MDButton
                  variant="gradient"
                  color="light"
                  onClick={() => {
                    setIsOpenUpdate(false);
                    setIsOpen(true);
                  }}
                >
                  Create Tax
                </MDButton>
              ) : null}
            </MDBox>
            <MDBox py={3}>
              {Loading ? (
                <SkLoading />
              ) : tax && tax.length > 0 ? (
                <DataTable
                  table={{
                    columns: columns?.AllTax,
                    rows: rowsData,
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  isPages={tax && tax.length}
                  noEndBorder
                  canSearch={false}
                  showTotalEntries={false}
                  isPagination={false}
                />
              ) : (
                <MDBox display="flex" justifyContent="center" gap={2} alignItems="center">
                  <MDTypography variant="h5">Tax Not Found ...!</MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={isOpen}
        unShow={setIsOpen}
        width={{ sx: "100%", md: "65%", xl: "65%", sm: "100%" }}
        height={"auto"}
        padding={3}
        overflowY={true}
      >
        <Form isOpenUpdate={isOpenUpdate} setIsOpenUpdate={setIsOpenUpdate} setIsOpen={setIsOpen} />
      </SkModal>
    </>
  );
};

export default Tax;
